export enum InlineInspirationCategories {
  business = 'business',
  design = 'design',
  education = 'education',
  engineering = 'engineering',
  marketing = 'marketing',
  'project-management' = 'project-management',
  'human-resources' = 'human-resources',
  operations = 'operations',
  sales = 'sales',
  other = 'other',
}
